import { getProductInfo } from './api';

/** 将接口商品行转为详情页使用的结构 */
export function normalizeProductRow(p, referralCode = '') {
  if (!p) return null;
  return {
    id: p.id,
    title: p.title,
    price: p.price,
    count: p.count,
    sell: p.sell,
    sendWay: p.sendWay,
    src: p.src,
    cate_id: p.cate_id,
    link_key: p.link_key,
    detail: p.detail,
    product_type: p.product_type,
    referral_code: referralCode,
  };
}

function resolveReferralCode(route) {
  return (
    route?.query?.code ||
    new URLSearchParams(window.location.search).get('code') ||
    ''
  );
}

/**
 * 从路由加载商品：优先 query.id / query.link_key，兼容旧版 /detail/:data JSON
 */
export async function loadProductForDetail(route) {
  const referralCode = resolveReferralCode(route);

  if (route.params?.data) {
    try {
      const legacy = JSON.parse(route.params.data);
      return {
        detail: {
          ...legacy,
          referral_code: legacy.referral_code || referralCode,
        },
        referralCode: legacy.referral_code || referralCode,
      };
    } catch {
      /* 继续走 API */
    }
  }

  const linkKey = route.query?.link_key;
  const id = route.query?.id;

  if (!linkKey && (id === undefined || id === null || id === '')) {
    throw new Error('缺少商品 id 或 link_key');
  }

  const params = linkKey ? { link_key: String(linkKey) } : { id: String(id) };
  const res = await getProductInfo(params);
  const row = res?.data;
  if (!row) {
    throw new Error(res?.message || '商品不存在');
  }

  const detail = normalizeProductRow(row, referralCode);
  return { detail, referralCode };
}
